import { createContext } from 'react';

var GlobalActionsContext = createContext({});
var GlobalActionsContextProvider = GlobalActionsContext.Provider;

export { GlobalActionsContext, GlobalActionsContextProvider };
//# sourceMappingURL=GlobalActionsContext.esm.js.map
